import React from 'react';
import { Typography, Box } from '@mui/material';

const ModalList = ({ list = [] }) => {
  if (!Array.isArray(list) || list.length === 0) return null;

  return (
    <Box component="ol" sx={{ pl: '1.25rem', m: 0 }}>
      {list.map((item, index) => (
        <li key={index} style={{ marginBottom: '1rem' }}>
          <Typography variant="body2" component="span">
            {item}
          </Typography>
        </li>
      ))}
    </Box>
  );
};

export default ModalList;
